const $$splitComponentImporter = () => import('/src/src/routes/(compatibility)/groups.$groupId.folders.$folderId.resources.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
/**
 * Redirect legacy group resources link to new group folder route
 *
 * @deprecated
 */
export const Route = createFileRoute("/(compatibility)/groups/$groupId/folders/$folderId/resources")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});